import store from "../../../Redux/store";
import { setFilterData, setListData, setPaginationData, setSearchInput, setSingleViewData } from "./payrollSlice";

export const clearRdxStateFunc = () => {
 
  store.dispatch(setListData(null))
  store.dispatch(setSingleViewData(null));
  store.dispatch(
    setPaginationData({
      currentPage: 1,
      totalPages: 1,
    })
  );
  store.dispatch(setSearchInput(""));
  store.dispatch(setFilterData(null))
};
